import AriaModal from 'react-aria-modal'
import React, { Component } from 'react'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'
import clients from 'redux/clients'
import moment from 'moment'
import { getOnlyNumbers } from 'Participant/ducks'
import Profile from './Profile'
import Address from './Address'
import { validate as validateCPF } from 'gerador-validador-cpf'

const getZipCode = value => {
  const number = value ? getOnlyNumbers(value) : ''
  return { value, number }
}

class ValidationModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modal: false,
      participant: null,
      modalIndividual: false,
      modalAddress: false,
      mobilePhone: null,
      personalEmail: null,
      disabled: {
        name: false,
        documentNumber: false,
        birthDate: false,
        ie: false,
        partnerCpf: false,
        personalEmail: false,
        mobilePhone: false,
        zipCode: false,
        street: false,
        number: false,
        complement: false,
        district: false,
        city: false,
        state: false
      },
      isLoading: false,
      validSave: true,
      checkoutObject: null,
      isCpf: true,
      emailExists: false,
      phoneExists: false,
      errors: {}
    }
  }

  componentDidMount () {
    this.getParticipant()
  }

  getParticipant () {
    clients.cloudloyalty.client
      .get('/v1/participants/me')
      .then((res) => {
        this.validateParticipant(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getMobilePhone (data) {
    const found = data.phones.find(x => x.type === 'MOBILE')
    if (found) {
      this.setState({ mobilePhone: `${found.areaCode}${found.number}`, phoneExists: true })
      return `${found.areaCode}${found.number}`
    }
    return ''
  }

  getPersonalEmail (data) {
    const found = data.emails.find(x => x.type === 'PERSONAL')
    if (found) {
      this.setState({ personalEmail: found.email, emailExists: true })
      return found.email
    }
    return ''
  }

  getBirthDate (birthDate) {
    return moment(birthDate).format('DD/MM/YYYY')
  }

  validateParticipant (data) {
    const mobilePhone = this.getMobilePhone(data)
    const personalEmail = this.getPersonalEmail(data)
    const isCpf = data.persontype === 'INDIVIDUAL'

    let validateIndividual = !data.name || !this.isNameValid(data.name) || !data.documentNumber || !personalEmail || !mobilePhone
    validateIndividual = isCpf ? (validateIndividual || !data.birthDate) : (validateIndividual || !data.ie || !data.partnerCpf)

    let validateAddress = !this.isZipCodeValid(data.address.zipCode) || !data.address.street || !data.address.number || !data.address.complement || !data.address.district || !data.address.city || !data.address.state
    let showModal = false

    if (validateIndividual || validateAddress) showModal = true

    if (validateAddress) {
      data.address.zipCode = undefined
      data.address.street = null
      data.address.district = null
      data.address.city = null
      data.address.state = null
    }

    const disabled = {
      name: this.isNameValid(data.name),
      documentNumber: !!data.documentNumber,
      birthDate: !!data.birthDate,
      ie: !!data.ie,
      partnerCpf: !!data.partnerCpf,
      personalEmail: !!personalEmail,
      mobilePhone: !!mobilePhone,
      zipCode: this.isZipCodeValid(data.address.zipCode),
      street: !!data.address.street,
      district: !!data.address.district,
      city: !!data.address.city,
      state: !!data.address.state
    }

    const errors = {
      ...disabled,
      number: !!data.address.number,
      complement: !!data.address.complement,
      reference: !!data.address.reference
    }

    if (isCpf) data.birthDate = this.getBirthDate(data.birthDate)

    window.sessionStorage.setItem('showModal', `${showModal}`)

    this.setState({
      participant: data,
      modal: showModal,
      disabled: disabled,
      errors: errors,
      modalIndividual: validateIndividual,
      modalAddress: validateAddress,
      isCpf: isCpf
    })

    if (!validateAddress && !data.address.reference) {
      data.address.reference = 'Não Informado'
      this.handleSubmit(true)
    }
  }

  validateZipCode = (zipCodeValue) => {
    const { number, value } = getZipCode(zipCodeValue)
    const isValid = this.isZipCodeValid(number)
    const zipCode = { value, number, isValid }
    this.setState({ zipCode })
    return zipCode
  }

  handleZipCode = ({ target: { value } }) => {
    this.setState({ isLoading: true })
    const zipCode = this.validateZipCode(value)
    const zipCodeNumber = zipCode.number
    const numberPattern = /^[0-9]*$/

    this.updateState('street', false, false, false, true)
    this.updateState('district', false, false, false, true)
    this.updateState('city', false, false, false, true)
    this.updateState('state', false, false, false, true)

    if (zipCodeNumber.length === 8 && numberPattern.test(zipCodeNumber)) {
      this.updateState('street', '', false, true)
      this.updateState('reference', '', false, true)
      this.updateState('complement', '', false, true)
      this.updateState('number', '', false, true)
      this.updateState('district', '', false, true)
      this.updateState('city', '', false, true)
      this.updateState('state', '', false, true)
      this.searchZipCode(zipCodeNumber)
    }
    this.setState({ isLoading: false })
  }

  searchZipCode = (zipCode) => {
    clients.cloudloyalty.client
      .get(`v1/addresses/${zipCode}`)
      .then((res) => {
        const data = res.data
        let state = this.state
        state.participant.address.street = `${data.streetType} ${data.street}`
        state.participant.address.district = data.district
        state.participant.address.city = data.city
        state.participant.address.state = data.state
        state.errors = this.isInputsValids(state)
        this.setState(state)
        this.updateState('street', !!state.participant.address.street.trim(), false, false, true)
        this.updateState('district', !!state.participant.address.district.trim(), false, false, true)
        this.updateState('city', !!state.participant.address.city.trim(), false, false, true)
        this.updateState('state', !!state.participant.address.state.trim(), false, false, true)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  isFormInvalid = () => {
    if (!this.state.participant) return true

    if (this.state.modalIndividual && this.isParticipantInvalid()) return true
    if (this.state.modalAddress && this.isAddressInvalid()) return true

    return false
  }

  // address test
  isZipCodeValid = value => !!value && value.replace(/\D/g, '').length === 8
  isDistrictValid = value => !!value && value.length >= 2
  isStreetValid = value => !!value && value.length > 2
  isComplementValid = value => !!value && (value.length >= 4 && value.length < 20)
  isNumberValid = value => {
    let isNumeric = !isNaN(parseFloat(value)) && isFinite(value)
    return (isNumeric || value === 's/n')
  }
  isReferenceValid = value => !!value && value.length >= 4

  isAddressInvalid = () => {
    if (!this.state.participant) return true
    let state = this.state.participant.address

    if (this.isZipCodeValid(state.zipCode) === false) return true
    if (this.isDistrictValid(state.district) === false) return true
    if (this.isStreetValid(state.street) === false) return true
    if (this.isComplementValid(state.complement) === false) return true
    if (this.isNumberValid(state.number) === false) return true
    if (this.isReferenceValid(state.reference) === false) return true
    if (!state.state) return true
    if (!state.city) return true

    return false
  }

  // participant test
  isNameValid = value => {
    const nameValidator = /^[\wÀ-Ÿ\-&\s()]+(?![http:https:])$/
    return !!value && nameValidator.test(value) && value.trim().split(' ').length > 1
  }

  isDocumentValid = value => {
    let documentLength = value.replace(/[-_./]/g, '').length

    const validLength = this.state.isCpf ? 11 : 14
    if (documentLength === validLength) return true

    return false
  }
  isPartnerCpfValid = value => {
    if (validateCPF(value)) return true
    return false
  }

  isBirthDateValid = value => !!value && value.replace(/[_/]/g, '').length === 8
  isMobilePhoneValid = value => !!value && value.replace(/\D/g, '').length >= 10
  isEmailValid = value => {
    const mailValidator = /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+)$/gim
    return !!value && mailValidator.test(value)
  }

  isParticipantInvalid = () => {
    let state = this.state.participant

    if (!this.isNameValid(state.name)) return true
    if (!this.isDocumentValid(state.documentNumber)) return true
    if (!this.isMobilePhoneValid(this.state.mobilePhone)) return true
    if (!this.isEmailValid(this.state.personalEmail)) return true

    if (this.state.isCpf) {
      if (!this.isBirthDateValid(state.birthDate)) return true
    } else {
      if (!state.ie) return true
      if (!state.partnerCpf && !this.isPartnerCpfValid(state.partnerCpf)) return true
    }

    return false
  }

  isInputsValids = (state) => {
    return {
      name: this.isNameValid(state.participant.name),
      documentNumber: this.isDocumentValid(state.participant.documentNumber),
      birthDate: this.isBirthDateValid(state.participant.birthDate),
      ie: !!state.participant.ie,
      partnerCpf: !!state.participant.partnerCpf && this.isPartnerCpfValid(state.participant.partnerCpf),
      personalEmail: this.isEmailValid(state.personalEmail),
      mobilePhone: this.isMobilePhoneValid(state.mobilePhone),
      zipCode: this.isZipCodeValid(state.participant.address.zipCode),
      street: this.isStreetValid(state.participant.address.street),
      number: this.isNumberValid(state.participant.address.number),
      complement: this.isComplementValid(state.participant.address.complement),
      district: this.isDistrictValid(state.participant.address.district),
      city: !!state.participant.address.city,
      state: !!state.participant.address.state,
      reference: this.isReferenceValid(state.participant.address.reference)
    }
  }

  formatToSend = () => {
    let state = this.state

    state.participant.address.zipCode = state.participant.address.zipCode.replace(/\D/g, '')

    let areaCode = state.mobilePhone.replace(/\D/g, '').substr(0, 2)
    let mobileNumber = state.mobilePhone.replace(/\D/g, '').substr(3, 9)

    if (!state.phoneExists) {
      state.participant.phones = [
        ...this.state.participant.phones,
        { type: 'MOBILE', areaCode: areaCode, number: mobileNumber }
      ]
    }

    if (!state.emailExists) {
      state.participant.emails = [
        ...this.state.participant.emails,
        { type: 'PERSONAL', email: this.state.personalEmail }
      ]
    }

    let customer = {
      documentNumber: state.participant.documentNumber,
      email: state.personalEmail,
      genderType: state.participant.genderType,
      name: state.participant.name,
      personType: state.participant.persontype,
      phones: state.participant.phones
    }

    if (state.isCpf) {
      state.participant.birthDate = moment(state.participant.birthDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
      customer.birthDate = state.participant.birthDate
    } else {
      customer.ie = state.participant.ie
      customer.partnerCpf = state.participant.partnerCpf
    }

    state.checkoutObject = {
      customer: customer,
      shippingAddress: {
        ...state.participant.address,
        receiver: state.participant.name
      }
    }
    this.setState(state)
  }

  submitParticipant = async () => {
    let bodyProfile = this.state.participant

    if (!this.state.isCpf) {
      bodyProfile = {
        ...bodyProfile,
        birthDate: '',
        companyName: bodyProfile.name,
        stateInscription: bodyProfile.ie,
        partnerCpf: bodyProfile.partnerCpf
      }
    }

    await clients.cloudloyalty.client
      .put('/v1/participants/me/profile', bodyProfile)
      .then((res) => {
        console.log(res)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  submitShipping = async () => {
    let bodyCheckout = this.state.checkoutObject
    await clients.cloudloyalty.client
      .put('/v1/carts/me/shipping', bodyCheckout)
      .then((res) => {
        console.log(res)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  handleSubmit = async (referenceTest = false) => {
    this.formatToSend()

    if (this.state.modalIndividual) await this.submitParticipant()
    if (this.state.modalAddress || referenceTest) await this.submitShipping()

    this.updateState('modal', false)
    window.sessionStorage.setItem('showModal', 'false')
  }

  updateState = (field, value, participant = false, address = false, disabled = false) => {
    let state = this.state
    if (participant) state.participant[field] = value
    else if (address) state.participant.address[field] = value
    else if (disabled) state.disabled[field] = value
    else state[field] = value
    state.errors = this.isInputsValids(state)
    this.setState(state)
  }

  modalHeight () {
    let modalHeight
    if (this.state.modalIndividual && this.state.modalAddress) modalHeight = '70vh'
    else if (this.state.modalAddress) modalHeight = '60vh'
    else modalHeight = '50vh'
    return modalHeight
  }

  render () {
    return (
      this.state.modal && (
        <AriaModal titleText='Recarregando' focusDialog='true' underlayStyle={{ zIndex: 9999 }}>
          <div className='container bg-white py-1' data-campaign={(this.props.profile && this.props.profile['custom:catalog_id']) || process.env.REACT_APP_CATALOG_ID}>
            <div className='row'>
              <div className='col-12'>
                <h2 className='txt-initial color-brand-1 mr-auto'>
                  Bem-vindo!
                </h2>
                <h2 className='txt-body-sm color-brand-12 txt-font-body mb-1'>Para continuar, precisamos de algumas informações que ainda não foram preenchidas</h2>
              </div>
            </div>
            <hr />
            {this.state.modalIndividual &&
              <Profile
                participant={this.state.participant}
                errors={this.state.errors}
                disabled={this.state.disabled}
                personalEmail={this.state.personalEmail}
                mobilePhone={this.state.mobilePhone}
                isCpf={this.state.isCpf}
                updateState={this.updateState}
              />
            }
            {this.state.modalAddress && (
              <Address
                address={this.state.participant.address}
                errors={this.state.errors}
                disabled={this.state.disabled}
                handleZipCode={this.handleZipCode}
                updateState={this.updateState}
              />
            )}
            {this.state.modal && (
              <div className='row'>
                <div className='col-12 mt-2'>
                  <Button
                    id='save'
                    name='save'
                    className='btn btn-sm txt-uppercase txt-center btn-featured'
                    text='Salvar'
                    loading={this.state.isLoading}
                    disabled={this.isFormInvalid()}
                    onClick={this.handleSubmit}
                  />
                </div>
              </div>
            )}
          </div>
        </AriaModal>
      )
    )
  }
}

ValidationModal.propTypes = {
  profile: PropTypes.object
}

export default ValidationModal



// WEBPACK FOOTER //
// ./src/features/UserInfosValidation/ValidationModal.js